var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLigtning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40498",
    "data-name": "Group 40498",
    transform: "translate(20214 8749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15347",
    "data-name": "Rectangle 15347",
    width: 24,
    height: 24,
    transform: "translate(-20214 -8749)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "thunder",
    d: "M84.665.839,83.491,8.693h6.223a.3.3,0,0,1,.3.3.287.287,0,0,1-.071.191l-8.913,12.2a.3.3,0,0,1-.416.064.294.294,0,0,1-.118-.281L81.668,13.3H75.445a.3.3,0,0,1-.3-.3.3.3,0,0,1,.069-.193L84.131.619a.3.3,0,0,1,.534.219Z",
    transform: "translate(-20284.578 -8747.999)",
    fill: "#fb0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLigtning);
export default __webpack_public_path__ + "static/media/ligtning.e02e87c22cb594f3cadac1c0d1d8778c.svg";
export { ForwardRef as ReactComponent };